import React from 'react';
import Hero from './HeroArea';
import Feature from './FeatureArea';
import About from './AboutArea';
import Service from './ServiceArea';
import Newsletter from './NewsletterArea';
import ChooseUs from './ChooseArea';
import FunFact from './FunFactArea';
import Team from './TeamArea';
import Cases from './CasesArea';
import Testimonial from './TestimonialArea';
import Blog from './BlogArea';

const HomeFourMain = () => {
  return (
    <main>
      <Hero />
      <Feature />
      <About />
      <Service />
      <Newsletter />
      <ChooseUs />
      <FunFact />
      <Team />
      <Cases />
      <Testimonial />
      <Blog />
    </main>
  );
};

export default HomeFourMain;
